import Vue from 'vue';
import FloatingVue from 'floating-vue'
import VueSweetalert2 from 'vue-sweetalert2';const hash = require('object-hash');
const VueScrollTo = require('vue-scrollto');

window.axios = require('axios');
window.Vue = Vue;
window.csrf_token = document.getElementById('csrf-token').value;
try {
  window.Popper = require('popper.js').default;
  window.$ = window.jQuery = require('jquery');
  require('bootstrap');
} catch (e) {
  console.log("Error when loading modules:",e);
}

Vue.use(FloatingVue);
Vue.prototype.base_url = baseUrl;
Vue.prototype.activeAds = activeAds;
Vue.use(VueSweetalert2);
Vue.use(VueScrollTo);

axios.defaults.headers = {
  'X-CSRF-TOKEN': document.getElementById('csrf-token').value,
  'X-Requested-With': 'XMLHttpRequest'
}

Vue.mixin({
  computed: {
    cookies() {
      let obj = {};
      return document.cookie.split('; ').reduce((cookies, ck) => {
        let cookie = ck.split('=');
        cookies[cookie[0]] = cookie[1];
        return cookies;
      }, {});
    }
  }
});


Vue.prototype.$loading = function() {
  if (this.$refs['vue-block']) {
    this.$refs['vue-block'].style.display = 'initial';
  }
  this.loaded = true;
};
Vue.prototype.hash = function(data) {
  return hash(data);
};
Vue.prototype.read_notation = function(nbre) {
  return read_notation(nbre);
};
Vue.prototype.alt = function() {
  return alt(Array.from(arguments));
};
Vue.prototype.alt_0 = function(){
  return alt_0(arguments);
};
Vue.prototype.asset = function(url){
  return config.assetUrl + '/' + url;
};
Vue.prototype.route = function(url, params) {
  return route(url, params);
};
Vue.prototype.route_mmp = function(url) {
  return config.routeMmp(url);
};
Vue.prototype.format_date = function(date, format) {
  return moment(new Date(date)).format(format);
};
Vue.prototype.short_title = function(title, size=12) {
  if(title.length <= size){
    return title;
  }else{
    return title.slice(0,size-2)+"...";
  }
};
Vue.prototype.k_notation=function(number){
  let n = Number(number);
  return n.k_notation;
}
Vue.prototype.date_format = function(date,format) {
  return moment(date).format(format);
};
Vue.prototype.componentByString = function (str) {
  return {template:str};
}
Vue.prototype.route_skill = function(grade,skill) {
  return route('grade.skill.show',{grade:grade,skill:skill});
};
Vue.prototype.route_topic = function(topic) {
  return route('topic.show',{topic:topic});
};
Vue.prototype.route_grade = function(grade) {
  return route('grade.show',{grade:grade});
};
Vue.prototype.copy = function(arg){
  return JSON.parse(JSON.stringify(arg));
};
Vue.prototype.array_unique = function(array) {
  return array.distinct();
};
Vue.prototype.format_date = function(date, format) {
  return moment(new Date(date)).format(format);
};

$(function () {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();
  if($('#page-summary-block')) {
    let pageSummary = new Vue({
      el: '#page-summary-block',
      data: {},
      methods: {},
      computed: {},
    });
  }
})

